<div id="map"></div>
<div class="map-address px-3">{{details}}</div>